export enum CsvEvergreen {
  EVERGREEN = 'evergreen',
  ONCE = 'once'
}

export enum CsvColumnNames {
  POST_TEXT = 'POST_TEXT',
  LINK = 'LINK',
  IMAGES = 'IMAGES',
  SCHEDULED_TIME = 'SCHEDULED_TIME',
  CATEGORY = 'CATEGORY',
  EVERGREEN = 'EVERGREEN',
  TITLE = 'TITLE',
  FIRST_COMMENT = 'FIRST_COMMENT'
}

export const CsvHeader = [
  'Post Text',
  'Link',
  'Images',
  'Scheduled Time: yyyy-mm-dd hh:mm',
  'Category',
  'Evergreen',
  'Title',
  'First Comment'
];

export enum ValidationErrorTypeEnum {
  FILE = 'FILE',
  DATA = 'DATA'
}

export const CsvTemplateData = [
  ['This post has text only', '', '', '', '', '', '', ''],
  ['', 'google.com', '', '', '', '', '', ''],
  [
    'This post has text and a link. The link will appear as an attached preview in Facebook/LinkedIn - or will be added to the end of a tweet.',
    'http://google.com',
    '',
    '',
    '',
    '',
    '',
    ''
  ],
  [
    'You can also include a link within the text - like this: google.com - useful if you want to have the link in the middle of the text.',
    '',
    '',
    '',
    '',
    '',
    '',
    ''
  ],
  [
    'This post is manually scheduled for a specific time. Use the time format (yyyy-mm-dd hh:mm) - and round the time to the nearest 5 minutes.',
    '',
    '',
    '2030-02-26 18:45',
    '',
    '',
    '',
    ''
  ],
  [
    'This post has text and an image. The image must be publicly accessible on the web, and be a valid JPG/PNG/WEBP file.',
    '',
    'http://via.placeholder.com/640x360.jpg',
    '',
    '',
    '',
    '',
    ''
  ],
  [
    'You can upload multiple images, by separating the image URLs with commas',
    '',
    'http://via.placeholder.com/400x400.jpg, http://via.placeholder.com/300x300.jpg',
    '',
    '',
    '',
    '',
    ''
  ],
  [
    'You can set which Category this post will be added to. Make sure the Category name matches one of your Categories accurately.',
    '',
    '',
    '',
    '[CATEOGRY_PLACEHOLDER]',
    '',
    '',
    ''
  ],
  [
    "Your 'Default Evergreen Setting' will determine whether your posts are imported as one-time posts, or Evergreen posts",
    '',
    '',
    '',
    '',
    '',
    '',
    ''
  ],
  [
    "Just write 'Once' in the 6th column if you don't want a specific post to be recycled",
    '',
    '',
    '',
    '',
    'Once',
    '',
    ''
  ],
  [
    "Or write 'Evergreen' in the 6th column if you do want a specific post to be recycled",
    '',
    '',
    '',
    '',
    'Evergreen',
    '',
    ''
  ],
  [
    "If importing a post for Pinterest, you can set the 'Title' in the 7th column",
    '',
    '',
    '',
    '',
    '',
    'Title goes here',
    ''
  ],
  [
    'For Instagram, Facebook, and LinkedIn, you can also set the First Comment in the 8th column',
    '',
    '',
    '',
    '',
    '',
    '',
    'This will be posted as the First Comment'
  ]
];
